var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKavkom = function SvgKavkom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32.5 49.1",
    viewBox: "0 0 32.5 49.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#238cf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0859ab"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 21.8252,
    x2: 44.0766,
    xlinkHref: "#a",
    y1: 20.1449,
    y2: 42.3963
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 18.0662,
    x2: 11.8162,
    xlinkHref: "#a",
    y1: 49.1025,
    y2: 19.1025
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#238cf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54a5f7"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 11.64,
    x2: 22.5522,
    xlinkHref: "#d",
    y1: 31.8721,
    y2: 31.8721
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 22.5247,
    x2: 27.8581,
    xlinkHref: "#a",
    y1: 16.3489,
    y2: 46.3489
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 4.3806,
    x2: 15.0473,
    xlinkHref: "#d",
    y1: 42.7598,
    y2: -1.2402
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 6.517,
    x2: 22.5492,
    xlinkHref: "#a",
    y1: 22.3049,
    y2: 22.3049
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.8 20c-.5.5-.8 1-1.1 1.5-1 1.9-1 4.1 0 6 .3.6.7 1.1 1.1 1.5 2.5 2.5 6.4 2.5 8.9 0s2.5-6.6 0-9.1c-2.5-2.4-6.4-2.4-8.9.1z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.3 33.7c-4.9-5-4.9-13.1 0-18.2l4.4-4.5c2.5-2.5 2.5-6.6 0-9.1-.9-.9-2-1.5-3.2-1.8-2-.4-4.1.2-5.7 1.8l-4.4 4.5c-9.8 10-9.8 26.3 0 36.3l4.4 4.5c1.5 1.6 3.7 2.2 5.7 1.8 1.2-.2 2.3-.8 3.2-1.8 2.5-2.5 2.5-6.6 0-9.1z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.7 47.3c.1-.1 0-.1 0 0z",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.2 38c4 4 3 8.7 2.5 9.2 2.4-2.5 2.4-6.5-.1-9l-4.4-4.5c-4.6-4.7-4.9-12.1-.9-17.1-.2.2-.3.3-.5.5-5.7 8.6-3.2 14.3 3.4 20.9z",
    fill: "url(#e)",
    opacity: 0.32
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m25.2 23.4c1.4-1.4 2-3.4 1.8-5.2-1.8-.2-3.7.4-5.2 1.8-.5.5-.8 1-1.1 1.5-.6 1.2-.8 2.4-.7 3.7 1.8.3 3.8-.3 5.2-1.8z",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m25.2 23.4c1.4-1.4 2-3.4 1.8-5.2-1.8-.2-3.7.4-5.2 1.8-.5.5-.8 1-1.1 1.5-.6 1.2-.8 2.4-.7 3.7 1.8.3 3.8-.3 5.2-1.8z",
    fill: "#fff",
    opacity: 0.16
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m22 3.7c-.3-.7-.7-1.3-1.3-1.8-.9-.9-2-1.5-3.2-1.8-2-.4-4.1.2-5.7 1.8l-4.4 4.5c-9.8 10-9.8 26.3 0 36.3 0 0-2.4-15.5 8.9-27.2l4.4-4.5c1.9-2 2.3-4.9 1.3-7.3z",
    fill: "url(#g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m16.3 15.5 4.4-4.5c1.9-2 2.3-4.9 1.3-7.3-.3-.7-.7-1.3-1.3-1.8 2.8 3.6-.8 7-2.9 9.1s-14.6 14.1-10.4 31.7c0 0-2.4-15.5 8.9-27.2z",
    fill: "url(#h)",
    opacity: 0.32
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKavkom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kavkom.46761ae7.svg";
export { ForwardRef as ReactComponent };